<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <h3
        class="kds-typography-title-xlarge"
        v-html="$t('b2b_self_test_pain_intensity_question')"
      />
      <ScoreSlider
        :label="getScoreSliderLabel"
        :max-score="10"
        :max-text="$t('b2b_self_test_pain_intensity_severe_pain')"
        :min-text="$t('b2b_self_test_pain_intensity_no_pain')"
        :score="getScoreSliderValue"
        data-q-a="score-slider"
        @change="handlePainIntensityChange"
        @tap="handlePainIntensityChange"
      />
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import ScoreSlider from '@shared/components/ScoreSlider.vue'
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'
import { computed } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'

const selfTestStore = useSelfTestStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const painIntensity = computed(() => selfTestStore.painIntensity)

const getScoreSliderValue = computed(() =>
  painIntensity.value === -1 ? 5 : painIntensity.value,
)

const getScoreSliderLabel = computed(() =>
  painIntensity.value === -1 ? '' : `${painIntensity.value}`,
)

const isValid = computed(
  () => painIntensity.value >= 0 && painIntensity.value <= 10,
)

const handlePainIntensityChange = ({ value }) => {
  selfTestStore.painIntensity = value
}
</script>
